import contract from './contract.json'
const config = {
  INFURA: {
    API: process.env.REACT_APP_INFURA_API
  },
  CONTRACT: {
    ABI: contract.MeritVerseABI,
    ADDRESS: contract.MeritVerseAddress
  },
  BACKEND: {
    URL: process.env.REACT_APP_BACKEND_URL
  }
}

export default config
